import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Container, Paragraph, Button, Modal } from '@scentregroup/ui'
import Article from '../article'
import MoviePoster from '../movie-poster'
import StarRating from '../star-rating'
import ExternalLink from '../external-link'
import Tabs from '../tabs'
import PageLanding from '../../components/page-landing'
import pageLandingStyle from '../../components/page-landing/index.module.scss'
import { withoutProtocol } from '../../helpers/url'
import style from './index.module.scss'
import MovieProviderBanner from './movie-provider-banner'

class MovieFeature extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
      activeTab: this.props.date ? this.getActiveTab() : 0,
    }
  }

  openModal = () => {
    this.setState({ modalOpen: true })
  }

  dismissModal = () => {
    this.setState({ modalOpen: false })
  }

  switchTabs = e => {
    this.setState({ activeTab: parseInt(e.target.getAttribute('index'), 10) })
  }

  getActiveTab = () => {
    const NUMBER_OF_TABS = 2
    const NOT_FOUND = -1
    const INDEX_FROM_URL = this.props.movie.sessions
      .map(date => date.date)
      .indexOf(this.props.date)

    if (INDEX_FROM_URL > NOT_FOUND) {
      return Math.min(INDEX_FROM_URL, NUMBER_OF_TABS)
    } else {
      return NUMBER_OF_TABS
    }
  }

  render() {
    const {
      movie: {
        image,
        genre,
        title,
        classification,
        backgroundImage,
        starRating,
        duration,
        synopsis,
        sessions,
        trailerUrl,
        trailerCaptions,
        flicksLink,
      },
      children,
    } = this.props

    const movieFeatureImage = {
      src: withoutProtocol(backgroundImage) || backgroundImage,
      alt: title,
    }

    return (
      <PageLanding
        desktopImage={movieFeatureImage}
        mobileImage={movieFeatureImage}
        imageDataTestId="movie-landing-image"
      >
        <Container
          className={classNames(
            style.container,
            pageLandingStyle.contentWrapper
          )}
        >
          <div className={style.wrapper}>
            <MoviePoster className={style.moviePoster} image={image} />
            <Article
              className={style.article}
              superheading={genre}
              heading={title}
              headerDataTestId="movie-genre"
              dataTestId="movie-title"
              headingType="medium"
            >
              <div className={style.movieDetails}>
                <Paragraph
                  className={style.classification}
                  aria-label="classification"
                >
                  {classification}
                </Paragraph>
                {Boolean(duration) && (
                  <Paragraph className={style.duration} aria-label="duration">
                    {duration}
                    <span className={style.durationLabel} aria-label="minutes">
                      mins
                    </span>
                  </Paragraph>
                )}
                {Boolean(starRating) && (
                  <StarRating
                    className={style.starRating}
                    starRating={starRating}
                  />
                )}
              </div>
            </Article>
            <div className={style.synopsisWrapper}>
              {trailerUrl && (
                <Button
                  className={style.trailerButton}
                  ariaLabel="open-trailer-modal"
                  onClick={this.openModal}
                >
                  Watch Trailer
                </Button>
              )}
              <Paragraph className={style.synopsis} dataTestId="movie-synopsis">
                {synopsis}
              </Paragraph>
            </div>
            <Tabs
              className={style.sessionTimes}
              activeTab={this.state.activeTab}
              tabHeadings={sessions.map(s => s.shortName)}
              onTabHeadingClick={this.switchTabs}
            >
              {sessions.map(date => (
                <section key={date.shortName}>
                  <Paragraph className={style.sessionTimeHeading}>
                    {date.name}
                  </Paragraph>
                  {date.sessions.map(session => (
                    <ExternalLink
                      key={session.time}
                      className={style.sessionTimeLink}
                      url={session.link}
                    >
                      {session.time}
                    </ExternalLink>
                  ))}
                </section>
              ))}
            </Tabs>
            <MovieProviderBanner flicksLink={flicksLink} />
          </div>
        </Container>
        {children}
        {trailerUrl && (
          <Modal
            isOpen={this.state.modalOpen}
            className={style.modal}
            onDismissButtonClick={this.dismissModal}
          >
            {this.state.modalOpen && (
              <video
                controls
                autoPlay
                className={style.videoPlayer}
                src={trailerUrl}
              >
                <track kind="captions" src={trailerCaptions} />
              </video>
            )}
          </Modal>
        )}
      </PageLanding>
    )
  }
}

MovieFeature.propTypes = {
  date: PropTypes.string,
  children: PropTypes.node,
  movie: PropTypes.object.isRequired,
}

export default MovieFeature
